export class EtapaModel {

    public codigo: number;
    public descricaoEtapa: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/etapa.model.ts